import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { QuizItem, QuizAnswer } from '../interfaces/quiz.interface';

@Injectable({
  providedIn: 'root',
})
export class QuizService {
  private readonly url = '@cec-api/quizzes';

  constructor(private http: HttpClient) {}

  getdevocional(): Promise<any> {
    return this.http.get(this.url).toPromise();
  }

  getQuizById(id: string | number): Promise<any> {
    return this.http.get(`${this.url}/${id}`).toPromise();
  }

  createQuiz(quiz: Partial<QuizItem>): Promise<any> {
    return this.http.post(this.url, quiz).toPromise();
  }

  updateQuiz(id: string | number, quiz: Partial<QuizItem>): Promise<any> {
    return this.http.put(`${this.url}/${id}`, quiz).toPromise();
  }

  deleteQuiz(id: string | number): Promise<any> {
    return this.http.delete(`${this.url}/${id}`).toPromise();
  }

  submitAnswer(quizId: string | number, answer: QuizAnswer): Promise<any> {
    return this.http.post(`${this.url}/${quizId}/answers`, answer).toPromise();
  }

  updateAnswer(answerId: string | number, answer: QuizAnswer): Promise<any> {
    return this.http.put(`@cec-api/quiz-answers/${answerId}`, answer).toPromise();
  }

  getAnswerById(id: string | number): Promise<any> {
    return this.http.get(`@cec-api/quiz-answers/${id}`).toPromise();
  }

  reviewAnswer(answerId: string | number, feedback: string): Promise<any> {
    return this.http.patch(`@cec-api/quiz-answers/${answerId}/review`, { reviewed_feedback: feedback }).toPromise();
  }
}
